const cloudApiBaseUrl = (import.meta.env.VITE_CLOUD_API_URL as string | undefined)?.trim();

export const isCloudConfigured = Boolean(cloudApiBaseUrl);
export const cloudApiBase = cloudApiBaseUrl?.replace(/\/$/, "") ?? "";
